import axios from "axios"

export default{
    Role:{
        async List(){
            const response = await axios.get(`/api/role/list`)
            return response
        },
        async GetSubRole(data){
            const response = await axios.get(`/api/role/getwithsubrole/${data}`)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/role/updatewithsubroles':'/api/role/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/role/delete/${data}`)
            return response
        }
    },
    MailSettings:{
        async Table(data){
            const response = await axios.post(`/api/systemmailoperations/systemmail/table`, data)
            return response
        },
        async GetMailSettingById(data){
            const response = await axios.get(`/api/systemmailoperations/systemmail/get/${data}`)
            return response
        },
        async GetMailSettingByKeyCode(data){
            const response = await axios.get(`/api/systemmailoperations/systemmail/get/${data}`)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/systemmailoperations/systemmail/update':'/api/systemmailoperations/systemmail/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/systemmailoperations/systemmail/delete/${data}`)
            return response
        },
        async Test(toMail,senderEmailId){
            const response = await axios.post(`/api/systemmailoperations/systemmail/sendtestmail/${toMail}/${senderEmailId}`)
            return response
        }
    },

}